<template>
  <div class="layout__container layout__padding-20-0">
    <div class="layout__padding-clear layout__width-50 text__align-center">
      <div class="layout__padding-20-0">
        <StepGuide :stepCount="3" />
      </div>
      <div class="">
        <h2 class="text__colour-teal">Thank you for placing your order with Ravensworth</h2>

        <div class="layout__padding-20-0">
          <p
            class="text__size-18 layout__margin__bottom-6"
          >
            Order Summary:
          </p>
          <p
            v-for="(printJob, index) in printJobs"
            :key="printJob.completedOrder.orderOutput.orderSummary.billing.orderId"
            :class="['text__size-16', {'layout__margin__bottom-6' : index !== printJobs.length - 1}]"
          >
            Item Reference: {{ printJob.completedOrder.orderOutput.orderSummary.billing.orderId == null ?
              printJob.completedOrder.orderOutput.orderSummary.billing.sourceId :
              printJob.completedOrder.orderOutput.orderSummary.billing.orderId}}
          </p>
        </div>
        <div class="">
          <p class="text__size-16">Delivery can be expected in 2-3 working days</p>
          <p class="text__size-16">If you have any queries, please contact</p>
          <div class="layout__padding-20-0">
            <p class="text__size-16">Ravensworth Client Services:</p>
            <p class="text__colour-teal text__size-16">0191 917 9331</p>
            <p class="text__colour-teal text__size-16">client.support@ravensworth.co.uk</p>
          </div>
        </div>

        <div class="layout__padding-20-0">
          <p class="text__size-16">You can also view your order by clicking on the button below.</p>
        </div>
        <el-button
          class="button-teal button__base layout__width-200px"
          @click="confirmation()"
        >
          View my orders
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Router from '../../../router';
import StepGuide from '@/components/tools/pdfupload/StepGuide.vue';
import { axios } from '@/mixins/Axios.js';
import { dataFormatter } from '@/mixins/DataFormatter.js';
import { backing } from '@/mixins/Backing.js';

export default {
  name: 'confirmation',

  components: {
    StepGuide,
  },

  props: {
    searchParams: Object,
    printJobs: Array,
  },

  mixins: [
    axios,
    dataFormatter,
    backing,
  ],

  data() {
    return {
      uploadPercentage: '',
    };
  },

  created() {
    if (! this.printJobs?.length) {
      Router.push({
        name: '/instant-print',
      });

      return;
    }

    window.sessionStorage.removeItem('_branchCode');
    window.sessionStorage.removeItem('_ipPreference');
    window.sessionStorage.removeItem('_filename');
    window.sessionStorage.removeItem('_propertyName');
    window.sessionStorage.removeItem('_reference');
    window.sessionStorage.removeItem('_source');
    window.sessionStorage.removeItem('_printJob');
    window.sessionStorage.removeItem('_printJobs');

    // const currentItems = JSON.parse(window.sessionStorage.getItem('_printJobs'));

    let instantPrint = 0;

    // if (currentItems?.length) {
    //   debugger;
    //   const jobs = currentItems.filter(currentItem => ! currentItems.map(printJob => printJob.Id).includes(currentItem.id));
    //
    //   console.log('jobs', jobs);
    //
    //   if (jobs.length) {
    //     instantPrint = jobs.length;
    //
    //     window.sessionStorage.setItem('_printJobs', JSON.stringify(jobs));
    //   } else {
    //     window.sessionStorage.removeItem('_printJobs');
    //   }
    // } else {
    //   window.sessionStorage.removeItem('_printJobs');
    // }

    const basketTotals = {
      instantPrint: 0,
    };

    this.$store.dispatch('incrementPhotofixrTotal', basketTotals);
  },

  methods: {
    next() {
      // Router.push({
      //     name: 'wizardProducts'
      // });
    },

    confirmation() {
      Router.push({
        name: '/orders/instant-print',
      });
    },
  },
};
</script>